import debounce from 'lodash/debounce'
import { Select } from 'antd'

const RemoteSelectV2 = props => {
  const {
    // From ANTD Form.Item wrapper. See docs for custom / 3rd party components for Forms
    id,
    value,
    onChange,
    // Other props
    onSearch,
    antd,
    placeholder = 'Search...',
  } = props

  const handleOnSearch = debounce(onSearch, 800)

  return (
    <Select
      // from ANTD Form
      id={id}
      value={value}
      onChange={onChange}
      // from ANTD Select
      showSearch
      allowClear
      defaultActiveFirstOption={false}
      filterOption={false}
      placeholder={placeholder}
      onSearch={handleOnSearch}
      // ANTD Select overrides
      {...antd}
    />
  )
}

export default RemoteSelectV2
